import React from 'react'
import { Card, Slider, Typography, Space, Row, Col } from 'antd'
import { BiRadar } from 'react-icons/bi'

interface RadiusSelectorProps {
  value: number
  onChange: (radius: number) => void
  disabled?: boolean
  min?: number
  max?: number
}

function RadiusSelector(props: RadiusSelectorProps) {
  const {
    value,
    onChange,
    disabled = false,
    min = 1,
    max = 50
  } = props
  const handleSliderChange = (newValue: number) => {
    onChange(newValue)
  }

  const getRadiusDescription = (radius: number): string => {
    if (radius <= 2) {
      return 'Very close - immediate neighborhood'
    }
    if (radius <= 5) {
      return 'Close - local area'
    }
    if (radius <= 10) {
      return 'Moderate - nearby suburbs'
    }
    if (radius <= 20) {
      return 'Wide - city district'
    }
    return 'Very wide - metropolitan area'
  }

  const marks = {
    1: 1,
    5: 5,
    10: 10,
    20: 20,
    30: 30,
    40: 40,
    50: 50
  }

  return (
    <Card
      title={
        <Space>
          <BiRadar />
          <Typography.Text strong>Notification Radius</Typography.Text>
        </Space>
      }
      size="small"
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Typography.Paragraph type="secondary" style={{ margin: 0 }}>
          Set the radius, in kilometers, around your selected location for incident notifications.
        </Typography.Paragraph>

        <Row gutter={16} align="middle">
          <Col flex={1}>
            <Slider
              min={min}
              max={max}
              value={value}
              onChange={handleSliderChange}
              marks={marks}
              disabled={disabled}
              tooltip={{
                formatter: (val) => `${val}km`
              }}
            />
          </Col>
        </Row>

        <div style={{ textAlign: 'center' }}>
          <Typography.Text strong style={{ fontSize: '16px' }}>
            {value} kilometer{value !== 1 ? 's' : ''}
          </Typography.Text>
          <br />
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            {getRadiusDescription(value)}
          </Typography.Text>
        </div>

        <Typography.Text type="secondary" style={{ fontSize: '11px', fontStyle: 'italic' }}>
          You will receive notifications for incidents that occur within this radius of your selected location.
        </Typography.Text>
      </Space>
    </Card>
  )
}

RadiusSelector.defaultProps = {
  disabled: false,
  min: 1,
  max: 50,
}

export default RadiusSelector
